// extracted by mini-css-extract-plugin
export default {"table":"table_table__5zT1d","large":"table_large__93K4-","row":"table_row__WVEcx"};